import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import profilePic from "../../Assets/profile-pic.jpg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hi There!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                I'M
                <strong className="main-name"> JANARDDAN SARKAR</strong>
              </h1>
              
              <h2 className="heading-subtitle">
                AI Engineer & Data Scientist
              </h2>
              
              <p className="heading-description">
                Specializing in <strong>Generative AI</strong>, <strong>Large Language Models (LLM)</strong>, 
                <strong>RAG Systems</strong>, and <strong>Deep Learning</strong>. 
                Based in <strong>Assam, India</strong>.
              </p>

              <div style={{ padding: 50, textAlign: "left" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={profilePic}
                alt="Janarddan Sarkar"
                className="img-fluid profile-pic"
                style={{ 
                  maxHeight: "450px",
                  borderRadius: "50%",
                  border: "4px solid #00d4ff",
                  boxShadow: "0 0 20px rgba(0, 212, 255, 0.3)"
                }}
              />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />
    </section>
  );
}

export default Home;
